import { gql } from '@apollo/client';

export const QUERY_USER_CRITERIA = gql`
  query QUERY_USER_CRITERIA {
    userCriteria @client {
      viewUser
      sortByUser
      searchUser
    }
  }
`;

export const MUTATION_UPDATE_VIEW = gql`
  mutation UpdateViewUser($view: String!) {
    updateViewUser(view: $view) @client
  }
`;

export const MUTATION_UPDATE_SORT_BY = gql`
  mutation UpdateSortByUser($sortBy: String!) {
    updateSortByUser(sortBy: $sortBy) @client
  }
`;

export const MUTATION_UPDATE_SEARCH = gql`
  mutation UpdateSearchUser($search: String!) {
    updateSearchUser(search: $search) @client
  }
`;

export const MUTATION_RESET_SEARCH = gql`
  mutation ResetSearchValuesUser($view: String!) {
    resetSearchValuesUser @client
  }
`;
